module.exports = __webpack_public_path__ + "img/representative_tokyo2020-08_08_2021.c4e7d114.jpg";